import React from "react";
import { NestedDropdown } from "dyl-components";
import { Controller } from "react-hook-form";
import { Form, Icon, Popup } from "semantic-ui-react";
import { PhoneUtil } from "utils";
import "../index.scss";

const CallQueueModal = ({
    control,
    onCheckDuplicatedName,
    queueStrategyOptions,
    greetingSoundOptions,
    announceAudioOptions,
    data,
    destinationOptions,
    callQueueExcludedParents,
    internalExtensionOptionsList,
    formatExtensionsOptions,
    unusedExtensions,
    isReadingUnusedExtensions,
    isReadingDestinations,
    watch,
    setValue
}) => {

    const announceSoundId = watch("announce_sound_id");
    if(announceSoundId === "none"){
        setValue("announce_delay",15);
    }

    return (
        <>
            <Form.Group widths="equal">
                <Controller
                    name={`label`}
                    control={control}
                    render={({
                        field: { name, value, onChange },
                        fieldState: { error },
                    }) => (
                        <Form.Input
                            name={name}
                            value={value}
                            onBlur={onCheckDuplicatedName}
                            error={error?.message}
                            onChange={(_, { value }) => {
                                onChange({ target: { name, value } });
                            }}
                            placeholder="Enter name"
                            label="Name"
                            required
                        />
                    )}
                />

                <Controller
                    name={`ring_time`}
                    control={control}
                    render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                            name={name}
                            value={value}
                            search
                            onChange={(_, { value }) => {
                                onChange({
                                    target: { name, value },
                                });
                            }}
                            label="Ring Duration"
                            placeholder={`Select Ring Duration`}
                            selectOnBlur={false}
                            options={PhoneUtil.RING_DURATION_OPTIONS}
                            required
                        />
                    )}
                />
                <Controller
                    name={`ring_strategy`}
                    control={control}
                    render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                            name={name}
                            value={value}
                            search
                            onChange={(_, { value }) => {
                                onChange({
                                    target: { name, value },
                                });
                            }}
                            label={"Queue Strategy"}
                            placeholder={`Select`}
                            selectOnBlur={false}
                            options={queueStrategyOptions}
                            required
                        />
                    )}
                />

                <Controller
                    name={`exit_key`}
                    control={control}
                    render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                            name={name}
                            value={value}
                            search
                            onChange={(_, { value }) => {
                                onChange({
                                    target: { name, value },
                                });
                            }}
                            label="Queue Exit Key"
                            placeholder={`Select`}
                            selectOnBlur={false}
                            width={4}
                            options={PhoneUtil.EXIT_KEY_OPTIONS}
                            required
                        />
                    )}
                />
            </Form.Group>

            <Form.Group>
                <Controller
                    name={`intro_sound_id`}
                    control={control}
                    render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                            name={name}
                            value={value}
                            search
                            onChange={(_, { value }) => {
                                onChange({
                                    target: { name, value },
                                });
                            }}
                            label={{
                                children: (
                                    <span>
                                        {"Introduction Audio"}
                                        {
                                            <Popup
                                                trigger={
                                                    <Icon
                                                        style={{
                                                            float: "right",
                                                            marginTop: "0.25em",
                                                        }}
                                                        name="fas fa-info-circle"
                                                        color="primary"
                                                    />
                                                }
                                                inverted
                                                content="Audio message played before calls ring through to the phones."
                                            />
                                        }
                                    </span>
                                ),
                            }}
                            placeholder={`Select Audio`}
                            selectOnBlur={false}
                            width={4}
                            options={greetingSoundOptions}
                        />
                    )}
                />

                <Controller
                    name="internal_extensions"
                    control={control}
                    render={({ field: { onChange, name, value } }) => {
                        return (
                            <Form.Checkbox
                                name={name}
                                className="displayOnOffClass"
                                checked={value}
                                toggle
                                label="Direct Extensions During Introduction"
                                onChange={(_, { checked }) => {
                                    onChange({
                                        target: {
                                            name,
                                            value: checked,
                                        },
                                    });
                                }}
                            />
                        );
                    }}
                />

                <Controller
                    name="view"
                    control={control}
                    render={({ field: { onChange, name, value } }) => {
                        return (
                            <Form.Checkbox
                                name={name}
                                className="displayOnOffClass"
                                checked={value}
                                toggle
                                label="Display on Office View"
                                onChange={(_, { checked }) => {
                                    onChange({
                                        target: {
                                            name,
                                            value: checked,
                                        },
                                    });
                                }}
                                width={4}
                            />
                        );
                    }}
                />
            </Form.Group>

            <Form.Group>
                <Controller
                    name={`announce_sound_id`}
                    control={control}
                    render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                            name={name}
                            value={value}
                            search
                            onChange={(_, { value }) => {
                                onChange({
                                    target: { name, value },
                                });
                            }}
                            label={{
                                children: (
                                    <span>
                                        Announce Audio
                                        <Popup
                                            trigger={
                                                <Icon
                                                    style={{
                                                        float: "right",
                                                        marginTop: "0.25em",
                                                    }}
                                                    name="fas fa-info-circle"
                                                    color="primary"
                                                />
                                            }
                                            inverted
                                            content="Audio played periodically for contacts in queue."
                                        />
                                    </span>
                                ),
                            }}
                            placeholder={`Select`}
                            selectOnBlur={false}
                            width={4}
                            options={announceAudioOptions}
                        />
                    )}
                />

                <Controller
                    name={`announce_delay`}
                    control={control}
                    render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                            name={name}
                            value={value}
                            search
                            onChange={(_, { value }) => {
                                onChange({
                                    target: { name, value },
                                });
                            }}
                            disabled={announceSoundId === "none"}
                            label="Announce Frequency"
                            placeholder={`Select`}
                            selectOnBlur={false}
                            options={PhoneUtil.RING_DURATION_OPTIONS}
                            width={4}
                        />
                    )}
                />

                <Controller
                    name={`destination_parent`}
                    control={control}
                    render={({
                        field: {
                            name: parentName,
                            value: parentValue,
                            onChange: onParentChange,
                        },
                    }) => (
                        <Controller
                            name={`after_destination_id`}
                            control={control}
                            render={({ field, fieldState: { error } }) => {
                                const {
                                    name: childName,
                                    value: childValue,
                                    onChange: onChildChange,
                                } = field;
                                return (
                                    <Form.Field
                                        control={NestedDropdown}
                                        child_value={
                                            data.label && !parentValue
                                                ? data?.after_destination
                                                      ?.destination_id
                                                : childValue
                                        }
                                        parent_value={
                                            data.label && !parentValue
                                                ? data?.after_destination?.type
                                                : parentValue
                                        }
                                        loading={isReadingDestinations}
                                        nested_options={destinationOptions}
                                        onChange={(
                                            _,
                                            { parent_value, child_value }
                                        ) => {
                                            onParentChange({
                                                target: {
                                                    name: parentName,
                                                    value: parent_value,
                                                },
                                            });
                                            onChildChange({
                                                target: {
                                                    name: childName,
                                                    value:
                                                        child_value ||
                                                        parent_value,
                                                },
                                            });
                                        }}
                                        excluded_parents={
                                            callQueueExcludedParents
                                        }
                                        placeholder="Select destination"
                                        display_parent
                                        selection
                                        label="No Answer Destination"
                                        pointing="top"
                                        width={4}
                                        required={true}
                                        error={error?.message}
                                        className="no_answer_destinations_nested_dropdown"
                                    />
                                );
                            }}
                        />
                    )}
                />

                <Controller
                    name={`alias`}
                    control={control}
                    render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                            name={name}
                            value={value}
                            loading={isReadingUnusedExtensions}
                            search
                            onChange={(_, { value }) => {
                                onChange({
                                    target: { name, value },
                                });
                            }}
                            label="Internal Extension"
                            placeholder={`Select Extension`}
                            selectOnBlur={false}
                            options={
                                data.label
                                    ? internalExtensionOptionsList
                                    : formatExtensionsOptions(unusedExtensions)
                            }
                            width={4}
                        />
                    )}
                />
            </Form.Group>
        </>
    );
};

export default CallQueueModal;
